import { LegalDocumentPage } from "@/components/legal/LegalDocumentPage";
import { legalDocuments } from "@/content/legalDocuments";

export default function Terms() {
  return <LegalDocumentPage document={legalDocuments.terms} />;
}